import React, { useState, useEffect } from "react";

const DocumentViewer = ({ AwsResumeUrl }) => {
  const [txtContent, setTxtContent] = useState("");
  
  // const fileExtension = AwsResumeUrl?.split(".")
  //   .pop()
  //   .split("?")[0]
  //   .toLowerCase();
    AwsResumeUrl = String(AwsResumeUrl || "");
    //console.log(AwsResumeUrl)
    const fileExtension = AwsResumeUrl?.split("?")[0]
    .split(".")
    .pop()
    .toLowerCase();
  useEffect(() => {
    if (AwsResumeUrl && fileExtension === "txt") {
      fetch(AwsResumeUrl)
        .then((res) => res.text())
        .then((text) => setTxtContent(text))
        .catch((err) => console.error("Error loading text file:", err));
    }
  }, [AwsResumeUrl, fileExtension]);
  //console.log(fileExtension)
  if (!AwsResumeUrl) {
    return (
      <div style={{ textAlign: "center" }}>
        <h6>No resume available.</h6>
      </div>
    );
  }

  if (fileExtension === "pdf") {
    console.log(AwsResumeUrl)
    return (
      <iframe
        src={AwsResumeUrl}
        title="Resume PDF"
        style={{ width: "100%", height: "80vh", border: "none" }}
      />
    );
  }

  if (["doc", "docx", "rtf"].includes(fileExtension)) {
    const microsoftViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
      AwsResumeUrl
    )}`;
    //console.log(microsoftViewerUrl)
    return (
      <iframe
        src={microsoftViewerUrl}
        title="Resume Document"
        style={{ width: "100%", height: "80vh", border: "none" }}
      />
    );
  }

  if (["html", "htm"].includes(fileExtension)) {
    return (
      <iframe
        src={AwsResumeUrl}
        title="Resume HTML"
        style={{ width: "100%", height: "80vh", border: "none" }}
      />
    );
  }

  if (fileExtension === "txt") {
    return (
      <div
        style={{
          whiteSpace: "pre-wrap",
          padding: "20px",
          border: "1px solid #ccc",
        }}
      >
        <h6>Resume TXT Content:</h6>
        <pre>{txtContent}</pre>
      </div>
    );
  }

  if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
    return (
      <div style={{ textAlign: "center" }}>
        <img
          src={AwsResumeUrl}
          alt="Resume Image"
          style={{ maxWidth: "100%", maxHeight: "80vh" }}
        />
      </div>
    );
  }
  return (
    <div style={{ width: "100%", height: "80vh" }}>
      <iframe
        src={AwsResumeUrl}
        title="Document Preview"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
};

export default DocumentViewer;
